/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';

import PageHeading from '../../../../components/common/PageHeading';
import RightBar from '../../../../components/common/RightBar';
import Footer from '../../../../components/common/Footer';
import RightBarMethod from '../../../../components/common/RightBar/RightBarMethod';

import './Template.css';

import { Form, Card, Col, Row, Table } from 'antd';
import { templates } from '../../../../data/templates';
import { TiArrowBack } from "react-icons/ti";
import { IoMdHelpCircle } from "react-icons/io";

const TemplateRightBar = [
    RightBarMethod("Tasks", "t1",<i className="fa-solid fa-star"></i>, [
        RightBarMethod("Assign Criteria to Policies", "1", "", "", "/generalsettings/screening-criteria/assign-criteria-to-policies"),
      ]),
      RightBarMethod("HELP TOPICS", "t2",<IoMdHelpCircle />, [
        RightBarMethod("Screening Criteria", "2", "", "", "/generalsettings/screening-criteria/screening-criteria"),
        RightBarMethod("Screening Policies", "3", "", "", "/generalsettings/screening-criteria/screening-policies"),
        RightBarMethod("Review Screening Result", "4", "", "", "/generalsettings/screening-criteria/review-screening-result"),
        RightBarMethod("Override a Preliminary Result", "5", "", "", "/generalsettings/screening-criteria/override-preliminary-result"),
      ]),
];

const data = {
    income: [
        {
            result: "Criteria met",
            monthlyIncome: "At least 3 times monthly rent"
        },
        {
            result: "Criteria not met",
            monthlyIncome: "Less than 3 times monthly rent"
        },
    ],
    credit: [
        {
            result: "Criteria met",
            score: "600 or higher"
        },
        {
            result: "Criteria met with co-signer",
            score: "200 - 599"
        },
        {
            result: "Criteria not met",
            score: "199 or lower"
        },
    ],
    accounts: [
        {
            result: "Criteria met with co-signer",
            account: "1 or more accounts in collections"
        },
    ],
    disputes: [
        {
            result: "Criteria met with co-signer",
            dispute: "Judgments in favor of landlord within the last 5 years"
        },
    ],
    registry: [
        {
            result: "Criteria not met",
            registry: "Found in OFAC/terrorist database records"
        },
    ],
};

function Template() {

    const [templatesData, setTemplatesData] = useState(templates)
    const [templateData, setTemplateData] = useState({});

    const { id } = useParams();
    const navigate = useNavigate();

    useEffect(()=>{

        const templateById = templatesData.find((template)=>{
            return template.id === Number(id);
        })

        setTemplateData(templateById);

    },[]);

    const incomeColumns = [
        {
            title: "Result",
            dataIndex: "result",
            key: "result"
        },
        {
            title: "Total Monthly Income of Applicant(s)",
            dataIndex: "monthlyIncome",
            key: "monthlyIncome"
        }
    ];

    const creditColumns = [
        {
            title: "Result",
            dataIndex: "result",
            key: "result"
        },
        {
            title: "Score",
            dataIndex: "score",
            key: "score"
        }
    ];

    const accountsColumns = [
        {
            title: "Result",
            dataIndex: "result",
            key: "result"
        },
        {
            title: "Accounts in Collections",
            dataIndex: "account",
            key: "account"
        }
    ];

    const rentalColumns = [
        {
            title: "Result",
            dataIndex: "result",
            key: "result"
        },
        {
            title: "Landlord-Tenant Disputes",
            dataIndex: "dispute",
            key: "dispute"
        }
    ];

    const RegistryColumns = [
        {
            title: "Result",
            dataIndex: "result",
            key: "result"
        },
        {
            title: "Registry",
            dataIndex: "registry",
            key: "registry"
        }
    ];

  return (
    <>
        <div className='page-container'>
        <div className="main-container">
            <div className="back-container" onClick={()=>navigate("/generalsettings/screening-criteria")}>
                <TiArrowBack size={20}/>
                <span>All criteria templates</span>
            </div>
            <PageHeading heading="Screening Criteria Template" />
               <Form labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                colon={false}>
                <Row gutter={[0,24]}>
                    <Col span={24}>
                        <Card title="Template Information">
                            <Form.Item label="Template Name">
                                <p>{templateData.templateName}</p>
                            </Form.Item>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title="Income">
                            <h4>Income-to-Rent Ratio</h4>
                            <div className="table-container">
                                <Table columns={incomeColumns} dataSource={data.income} pagination={false}/>
                            </div>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title="Credit History">
                            <div className="credit-history-container">
                                <Form.Item label="No Credit File/Score">
                                    <p>Criteria not met</p>
                                </Form.Item>
                                <div className="credit">
                                <h4>Credit Score</h4>
                                <div className="table-container">
                                    <Table columns={creditColumns} dataSource={data.credit} pagination={false}/>
                                </div>
                                </div>
                                <div className="accounts">
                                <h4>Accounts in Collection</h4>
                                <div className="table-container">
                                    <Table columns={accountsColumns} dataSource={data.accounts} pagination={false}/>
                                </div>
                                </div>
                                <Form.Item label="Calculation Excludes" className='flex-start'>
                                    <p>Accounts less than $300.00</p>
                                    <p>Medical Accounts</p>
                                </Form.Item>
                            </div>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title="Rental History">
                            <h4>Landlord-Tenant Disputes <span>(Judgments for Landlord)</span></h4>
                            <div className="table-container">
                                <Table columns={rentalColumns} dataSource={data.disputes} pagination={false}/>
                            </div>
                        </Card>
                    </Col>
                    <Col span={24}>
                        <Card title="Registries">
                            <div className="table-container">
                                <Table columns={RegistryColumns} dataSource={data.registry} pagination={false}/>
                            </div>
                        </Card>
                    </Col>
                </Row>
               </Form>
               <Footer />
        </div>
        </div>
        <div className="RightSidebar">
            <RightBar RightBarData={TemplateRightBar}/>
        </div>
    </>
  )
}

export default Template;
